module.exports = __webpack_public_path__ + "img/slide1.3a96700b.jpg";